import { HTMLAttributes, ReactNode } from 'react';
import './style.scss';

type SubHeadlineProps = HTMLAttributes<HTMLHeadingElement> & {
  children: ReactNode;
};

const SubHeadline = (props: SubHeadlineProps) => (
  <h3 className="sub-headline" {...props}>
    {props.children}
  </h3>
);

export default SubHeadline;
